export default __webpack_public_path__ + "static/media/lightNftCard.57597fc5.png";